import axiosInstance from "../axiosInterceptor";

export async function getBrand() {
  try{
    const response = await axiosInstance.get(`brand/getWithoutPaginationBrand`);
    const data = response?.data;
    return data;
  }catch(error){
   return {isSuccess:false,message:error.message || "Something went wrong! Please try again later.",data:[]}
  }
}
